import * as React from 'react'
import { Container } from '@mui/material'
import EventBanner from 'Widgets/EventBanner'
import SignUpGuest from 'Components/SignUpGuest'
import useEventStore from 'Store/eventStore'
import { ThemeProvider } from '@mui/material'
import eventTheme from 'Settings/themes/eventTheme'
import Hero from 'Components/Hero'

interface Props {}
const Register: React.FC<Props> = () => {
      const event = useEventStore((state) => state.event)
      const eventConfig = event ? event.config : null
      return (
            <ThemeProvider theme={() => eventTheme(eventConfig)}>
                  <Container maxWidth="lg" sx={{ padding: '0' }}>
                        {event && (
                              <>
                                    <EventBanner />
                                    <Hero />
                              </>
                        )}
                        <SignUpGuest />
                  </Container>
            </ThemeProvider>
      )
}
export default Register
